// Curated list of 305 popular Google Fonts for brand identity picker
// Sorted alphabetically. Each entry: { name, slug, category }
// slug is the Google Fonts CSS API format (spaces replaced with +)

const GOOGLE_FONTS = [
  { name: 'ABeeZee', slug: 'ABeeZee', category: 'sans-serif' },
  { name: 'Abel', slug: 'Abel', category: 'sans-serif' },
  { name: 'Abril Fatface', slug: 'Abril+Fatface', category: 'display' },
  { name: 'Aclonica', slug: 'Aclonica', category: 'sans-serif' },
  { name: 'Acme', slug: 'Acme', category: 'sans-serif' },
  { name: 'Albert Sans', slug: 'Albert+Sans', category: 'sans-serif' },
  { name: 'Alegreya', slug: 'Alegreya', category: 'serif' },
  { name: 'Alegreya Sans', slug: 'Alegreya+Sans', category: 'sans-serif' },
  { name: 'Alfa Slab One', slug: 'Alfa+Slab+One', category: 'display' },
  { name: 'Alice', slug: 'Alice', category: 'serif' },
  { name: 'Alike', slug: 'Alike', category: 'serif' },
  { name: 'Amatic SC', slug: 'Amatic+SC', category: 'handwriting' },
  { name: 'Amiri', slug: 'Amiri', category: 'serif' },
  { name: 'Andika', slug: 'Andika', category: 'sans-serif' },
  { name: 'Anton', slug: 'Anton', category: 'sans-serif' },
  { name: 'Archivo', slug: 'Archivo', category: 'sans-serif' },
  { name: 'Archivo Black', slug: 'Archivo+Black', category: 'sans-serif' },
  { name: 'Archivo Narrow', slug: 'Archivo+Narrow', category: 'sans-serif' },
  { name: 'Arimo', slug: 'Arimo', category: 'sans-serif' },
  { name: 'Arvo', slug: 'Arvo', category: 'serif' },
  { name: 'Asap', slug: 'Asap', category: 'sans-serif' },
  { name: 'Asar', slug: 'Asar', category: 'serif' },
  { name: 'Asap Condensed', slug: 'Asap+Condensed', category: 'sans-serif' },
  { name: 'Assistant', slug: 'Assistant', category: 'sans-serif' },
  { name: 'Atkinson Hyperlegible', slug: 'Atkinson+Hyperlegible', category: 'sans-serif' },
  { name: 'Azeret Mono', slug: 'Azeret+Mono', category: 'monospace' },
  { name: 'Bangers', slug: 'Bangers', category: 'display' },
  { name: 'Barlow', slug: 'Barlow', category: 'sans-serif' },
  { name: 'Barlow Condensed', slug: 'Barlow+Condensed', category: 'sans-serif' },
  { name: 'Barlow Semi Condensed', slug: 'Barlow+Semi+Condensed', category: 'sans-serif' },
  { name: 'Be Vietnam Pro', slug: 'Be+Vietnam+Pro', category: 'sans-serif' },
  { name: 'Bebas Neue', slug: 'Bebas+Neue', category: 'sans-serif' },
  { name: 'Belleza', slug: 'Belleza', category: 'sans-serif' },
  { name: 'BioRhyme', slug: 'BioRhyme', category: 'serif' },
  { name: 'Bitter', slug: 'Bitter', category: 'serif' },
  { name: 'Black Han Sans', slug: 'Black+Han+Sans', category: 'sans-serif' },
  { name: 'Bodoni Moda', slug: 'Bodoni+Moda', category: 'serif' },
  { name: 'Bree Serif', slug: 'Bree+Serif', category: 'serif' },
  { name: 'Bricolage Grotesque', slug: 'Bricolage+Grotesque', category: 'sans-serif' },
  { name: 'Cabin', slug: 'Cabin', category: 'sans-serif' },
  { name: 'Cabin Condensed', slug: 'Cabin+Condensed', category: 'sans-serif' },
  { name: 'Cairo', slug: 'Cairo', category: 'sans-serif' },
  { name: 'Cantarell', slug: 'Cantarell', category: 'sans-serif' },
  { name: 'Cantata One', slug: 'Cantata+One', category: 'serif' },
  { name: 'Cardo', slug: 'Cardo', category: 'serif' },
  { name: 'Catamaran', slug: 'Catamaran', category: 'sans-serif' },
  { name: 'Caveat', slug: 'Caveat', category: 'handwriting' },
  { name: 'Chakra Petch', slug: 'Chakra+Petch', category: 'sans-serif' },
  { name: 'Chivo', slug: 'Chivo', category: 'sans-serif' },
  { name: 'Cinzel', slug: 'Cinzel', category: 'serif' },
  { name: 'Cinzel Decorative', slug: 'Cinzel+Decorative', category: 'display' },
  { name: 'Coda', slug: 'Coda', category: 'display' },
  { name: 'Comfortaa', slug: 'Comfortaa', category: 'display' },
  { name: 'Commissioner', slug: 'Commissioner', category: 'sans-serif' },
  { name: 'Concert One', slug: 'Concert+One', category: 'display' },
  { name: 'Corben', slug: 'Corben', category: 'display' },
  { name: 'Cormorant', slug: 'Cormorant', category: 'serif' },
  { name: 'Cormorant Garamond', slug: 'Cormorant+Garamond', category: 'serif' },
  { name: 'Cormorant Infant', slug: 'Cormorant+Infant', category: 'serif' },
  { name: 'Courgette', slug: 'Courgette', category: 'handwriting' },
  { name: 'Crimson Pro', slug: 'Crimson+Pro', category: 'serif' },
  { name: 'Crimson Text', slug: 'Crimson+Text', category: 'serif' },
  { name: 'Cuprum', slug: 'Cuprum', category: 'sans-serif' },
  { name: 'DM Mono', slug: 'DM+Mono', category: 'monospace' },
  { name: 'DM Sans', slug: 'DM+Sans', category: 'sans-serif' },
  { name: 'DM Serif Display', slug: 'DM+Serif+Display', category: 'serif' },
  { name: 'DM Serif Text', slug: 'DM+Serif+Text', category: 'serif' },
  { name: 'Dancing Script', slug: 'Dancing+Script', category: 'handwriting' },
  { name: 'Darker Grotesque', slug: 'Darker+Grotesque', category: 'sans-serif' },
  { name: 'Dela Gothic One', slug: 'Dela+Gothic+One', category: 'display' },
  { name: 'Didact Gothic', slug: 'Didact+Gothic', category: 'sans-serif' },
  { name: 'Domine', slug: 'Domine', category: 'serif' },
  { name: 'Dosis', slug: 'Dosis', category: 'sans-serif' },
  { name: 'EB Garamond', slug: 'EB+Garamond', category: 'serif' },
  { name: 'El Messiri', slug: 'El+Messiri', category: 'sans-serif' },
  { name: 'Encode Sans', slug: 'Encode+Sans', category: 'sans-serif' },
  { name: 'Encode Sans Condensed', slug: 'Encode+Sans+Condensed', category: 'sans-serif' },
  { name: 'Epilogue', slug: 'Epilogue', category: 'sans-serif' },
  { name: 'Euphoria Script', slug: 'Euphoria+Script', category: 'handwriting' },
  { name: 'Exo', slug: 'Exo', category: 'sans-serif' },
  { name: 'Exo 2', slug: 'Exo+2', category: 'sans-serif' },
  { name: 'Expletus Sans', slug: 'Expletus+Sans', category: 'display' },
  { name: 'Faustina', slug: 'Faustina', category: 'serif' },
  { name: 'Figtree', slug: 'Figtree', category: 'sans-serif' },
  { name: 'Fira Code', slug: 'Fira+Code', category: 'monospace' },
  { name: 'Fira Sans', slug: 'Fira+Sans', category: 'sans-serif' },
  { name: 'Fira Sans Condensed', slug: 'Fira+Sans+Condensed', category: 'sans-serif' },
  { name: 'Fjalla One', slug: 'Fjalla+One', category: 'sans-serif' },
  { name: 'Flamenco', slug: 'Flamenco', category: 'display' },
  { name: 'Francois One', slug: 'Francois+One', category: 'sans-serif' },
  { name: 'Frank Ruhl Libre', slug: 'Frank+Ruhl+Libre', category: 'serif' },
  { name: 'Fredoka', slug: 'Fredoka', category: 'sans-serif' },
  { name: 'Fraunces', slug: 'Fraunces', category: 'serif' },
  { name: 'Gabarito', slug: 'Gabarito', category: 'display' },
  { name: 'Gelasio', slug: 'Gelasio', category: 'serif' },
  { name: 'Gentium Book Plus', slug: 'Gentium+Book+Plus', category: 'serif' },
  { name: 'Gilda Display', slug: 'Gilda+Display', category: 'serif' },
  { name: 'Gloria Hallelujah', slug: 'Gloria+Hallelujah', category: 'handwriting' },
  { name: 'Google Sans', slug: 'Google+Sans', category: 'sans-serif' },
  { name: 'Gothic A1', slug: 'Gothic+A1', category: 'sans-serif' },
  { name: 'Graduate', slug: 'Graduate', category: 'display' },
  { name: 'Great Vibes', slug: 'Great+Vibes', category: 'handwriting' },
  { name: 'Gruppo', slug: 'Gruppo', category: 'sans-serif' },
  { name: 'Hanken Grotesk', slug: 'Hanken+Grotesk', category: 'sans-serif' },
  { name: 'Heebo', slug: 'Heebo', category: 'sans-serif' },
  { name: 'Hind', slug: 'Hind', category: 'sans-serif' },
  { name: 'Hind Madurai', slug: 'Hind+Madurai', category: 'sans-serif' },
  { name: 'Hind Siliguri', slug: 'Hind+Siliguri', category: 'sans-serif' },
  { name: 'Hind Vadodara', slug: 'Hind+Vadodara', category: 'sans-serif' },
  { name: 'IBM Plex Mono', slug: 'IBM+Plex+Mono', category: 'monospace' },
  { name: 'IBM Plex Sans', slug: 'IBM+Plex+Sans', category: 'sans-serif' },
  { name: 'IBM Plex Sans Arabic', slug: 'IBM+Plex+Sans+Arabic', category: 'sans-serif' },
  { name: 'IBM Plex Sans Condensed', slug: 'IBM+Plex+Sans+Condensed', category: 'sans-serif' },
  { name: 'IBM Plex Serif', slug: 'IBM+Plex+Serif', category: 'serif' },
  { name: 'Inconsolata', slug: 'Inconsolata', category: 'monospace' },
  { name: 'Indie Flower', slug: 'Indie+Flower', category: 'handwriting' },
  { name: 'Instrument Sans', slug: 'Instrument+Sans', category: 'sans-serif' },
  { name: 'Instrument Serif', slug: 'Instrument+Serif', category: 'serif' },
  { name: 'Inter', slug: 'Inter', category: 'sans-serif' },
  { name: 'Inter Tight', slug: 'Inter+Tight', category: 'sans-serif' },
  { name: 'JetBrains Mono', slug: 'JetBrains+Mono', category: 'monospace' },
  { name: 'Josefin Sans', slug: 'Josefin+Sans', category: 'sans-serif' },
  { name: 'Josefin Slab', slug: 'Josefin+Slab', category: 'serif' },
  { name: 'Jost', slug: 'Jost', category: 'sans-serif' },
  { name: 'Julius Sans One', slug: 'Julius+Sans+One', category: 'sans-serif' },
  { name: 'K2D', slug: 'K2D', category: 'sans-serif' },
  { name: 'Kalam', slug: 'Kalam', category: 'handwriting' },
  { name: 'Kanit', slug: 'Kanit', category: 'sans-serif' },
  { name: 'Karla', slug: 'Karla', category: 'sans-serif' },
  { name: 'Khand', slug: 'Khand', category: 'sans-serif' },
  { name: 'Kumbh Sans', slug: 'Kumbh+Sans', category: 'sans-serif' },
  { name: 'Laila', slug: 'Laila', category: 'serif' },
  { name: 'Lato', slug: 'Lato', category: 'sans-serif' },
  { name: 'League Spartan', slug: 'League+Spartan', category: 'sans-serif' },
  { name: 'Lexend', slug: 'Lexend', category: 'sans-serif' },
  { name: 'Lexend Deca', slug: 'Lexend+Deca', category: 'sans-serif' },
  { name: 'Libre Baskerville', slug: 'Libre+Baskerville', category: 'serif' },
  { name: 'Libre Bodoni', slug: 'Libre+Bodoni', category: 'serif' },
  { name: 'Libre Caslon Display', slug: 'Libre+Caslon+Display', category: 'serif' },
  { name: 'Libre Caslon Text', slug: 'Libre+Caslon+Text', category: 'serif' },
  { name: 'Libre Franklin', slug: 'Libre+Franklin', category: 'sans-serif' },
  { name: 'Lilita One', slug: 'Lilita+One', category: 'display' },
  { name: 'Literata', slug: 'Literata', category: 'serif' },
  { name: 'Lobster', slug: 'Lobster', category: 'display' },
  { name: 'Lobster Two', slug: 'Lobster+Two', category: 'display' },
  { name: 'Lora', slug: 'Lora', category: 'serif' },
  { name: 'Lusitana', slug: 'Lusitana', category: 'serif' },
  { name: 'Macondo', slug: 'Macondo', category: 'display' },
  { name: 'Maiden Orange', slug: 'Maiden+Orange', category: 'serif' },
  { name: 'Mallanna', slug: 'Mallanna', category: 'sans-serif' },
  { name: 'Manrope', slug: 'Manrope', category: 'sans-serif' },
  { name: 'Marcellus', slug: 'Marcellus', category: 'serif' },
  { name: 'Marcellus SC', slug: 'Marcellus+SC', category: 'serif' },
  { name: 'Martel', slug: 'Martel', category: 'serif' },
  { name: 'Maven Pro', slug: 'Maven+Pro', category: 'sans-serif' },
  { name: 'Merienda', slug: 'Merienda', category: 'handwriting' },
  { name: 'Merriweather', slug: 'Merriweather', category: 'serif' },
  { name: 'Merriweather Sans', slug: 'Merriweather+Sans', category: 'sans-serif' },
  { name: 'Montserrat', slug: 'Montserrat', category: 'sans-serif' },
  { name: 'Montserrat Alternates', slug: 'Montserrat+Alternates', category: 'sans-serif' },
  { name: 'Mukta', slug: 'Mukta', category: 'sans-serif' },
  { name: 'Mulish', slug: 'Mulish', category: 'sans-serif' },
  { name: 'Nanum Gothic', slug: 'Nanum+Gothic', category: 'sans-serif' },
  { name: 'Nanum Gothic Coding', slug: 'Nanum+Gothic+Coding', category: 'monospace' },
  { name: 'Nanum Myeongjo', slug: 'Nanum+Myeongjo', category: 'serif' },
  { name: 'Neuton', slug: 'Neuton', category: 'serif' },
  { name: 'Newsreader', slug: 'Newsreader', category: 'serif' },
  { name: 'Noticia Text', slug: 'Noticia+Text', category: 'serif' },
  { name: 'Noto Sans', slug: 'Noto+Sans', category: 'sans-serif' },
  { name: 'Noto Sans Arabic', slug: 'Noto+Sans+Arabic', category: 'sans-serif' },
  { name: 'Noto Sans Display', slug: 'Noto+Sans+Display', category: 'sans-serif' },
  { name: 'Noto Sans Hebrew', slug: 'Noto+Sans+Hebrew', category: 'sans-serif' },
  { name: 'Noto Sans JP', slug: 'Noto+Sans+JP', category: 'sans-serif' },
  { name: 'Noto Sans KR', slug: 'Noto+Sans+KR', category: 'sans-serif' },
  { name: 'Noto Sans Mono', slug: 'Noto+Sans+Mono', category: 'monospace' },
  { name: 'Noto Sans SC', slug: 'Noto+Sans+SC', category: 'sans-serif' },
  { name: 'Noto Sans TC', slug: 'Noto+Sans+TC', category: 'sans-serif' },
  { name: 'Noto Serif', slug: 'Noto+Serif', category: 'serif' },
  { name: 'Noto Serif Display', slug: 'Noto+Serif+Display', category: 'serif' },
  { name: 'Noto Serif JP', slug: 'Noto+Serif+JP', category: 'serif' },
  { name: 'Nunito', slug: 'Nunito', category: 'sans-serif' },
  { name: 'Nunito Sans', slug: 'Nunito+Sans', category: 'sans-serif' },
  { name: 'Old Standard TT', slug: 'Old+Standard+TT', category: 'serif' },
  { name: 'Onest', slug: 'Onest', category: 'sans-serif' },
  { name: 'Open Sans', slug: 'Open+Sans', category: 'sans-serif' },
  { name: 'Orbitron', slug: 'Orbitron', category: 'sans-serif' },
  { name: 'Oswald', slug: 'Oswald', category: 'sans-serif' },
  { name: 'Outfit', slug: 'Outfit', category: 'sans-serif' },
  { name: 'Overpass', slug: 'Overpass', category: 'sans-serif' },
  { name: 'Overpass Mono', slug: 'Overpass+Mono', category: 'monospace' },
  { name: 'Oxygen', slug: 'Oxygen', category: 'sans-serif' },
  { name: 'Oxygen Mono', slug: 'Oxygen+Mono', category: 'monospace' },
  { name: 'PT Mono', slug: 'PT+Mono', category: 'monospace' },
  { name: 'PT Sans', slug: 'PT+Sans', category: 'sans-serif' },
  { name: 'PT Sans Caption', slug: 'PT+Sans+Caption', category: 'sans-serif' },
  { name: 'PT Sans Narrow', slug: 'PT+Sans+Narrow', category: 'sans-serif' },
  { name: 'PT Serif', slug: 'PT+Serif', category: 'serif' },
  { name: 'Pacifico', slug: 'Pacifico', category: 'handwriting' },
  { name: 'Padauk', slug: 'Padauk', category: 'sans-serif' },
  { name: 'Palanquin', slug: 'Palanquin', category: 'sans-serif' },
  { name: 'Palanquin Dark', slug: 'Palanquin+Dark', category: 'sans-serif' },
  { name: 'Passion One', slug: 'Passion+One', category: 'display' },
  { name: 'Pathway Gothic One', slug: 'Pathway+Gothic+One', category: 'sans-serif' },
  { name: 'Patrick Hand', slug: 'Patrick+Hand', category: 'handwriting' },
  { name: 'Patua One', slug: 'Patua+One', category: 'display' },
  { name: 'Permanent Marker', slug: 'Permanent+Marker', category: 'handwriting' },
  { name: 'Philosopher', slug: 'Philosopher', category: 'sans-serif' },
  { name: 'Play', slug: 'Play', category: 'sans-serif' },
  { name: 'Playfair Display', slug: 'Playfair+Display', category: 'serif' },
  { name: 'Playfair Display SC', slug: 'Playfair+Display+SC', category: 'serif' },
  { name: 'Plus Jakarta Sans', slug: 'Plus+Jakarta+Sans', category: 'sans-serif' },
  { name: 'Poppins', slug: 'Poppins', category: 'sans-serif' },
  { name: 'Pragati Narrow', slug: 'Pragati+Narrow', category: 'sans-serif' },
  { name: 'Prata', slug: 'Prata', category: 'serif' },
  { name: 'Pridi', slug: 'Pridi', category: 'serif' },
  { name: 'Prompt', slug: 'Prompt', category: 'sans-serif' },
  { name: 'Protest Guerrilla', slug: 'Protest+Guerrilla', category: 'display' },
  { name: 'Public Sans', slug: 'Public+Sans', category: 'sans-serif' },
  { name: 'Quattrocento', slug: 'Quattrocento', category: 'serif' },
  { name: 'Quattrocento Sans', slug: 'Quattrocento+Sans', category: 'sans-serif' },
  { name: 'Questrial', slug: 'Questrial', category: 'sans-serif' },
  { name: 'Quicksand', slug: 'Quicksand', category: 'sans-serif' },
  { name: 'Rajdhani', slug: 'Rajdhani', category: 'sans-serif' },
  { name: 'Raleway', slug: 'Raleway', category: 'sans-serif' },
  { name: 'Readex Pro', slug: 'Readex+Pro', category: 'sans-serif' },
  { name: 'Recursive', slug: 'Recursive', category: 'sans-serif' },
  { name: 'Red Hat Display', slug: 'Red+Hat+Display', category: 'sans-serif' },
  { name: 'Red Hat Mono', slug: 'Red+Hat+Mono', category: 'monospace' },
  { name: 'Red Hat Text', slug: 'Red+Hat+Text', category: 'sans-serif' },
  { name: 'Righteous', slug: 'Righteous', category: 'display' },
  { name: 'Roboto', slug: 'Roboto', category: 'sans-serif' },
  { name: 'Roboto Condensed', slug: 'Roboto+Condensed', category: 'sans-serif' },
  { name: 'Roboto Flex', slug: 'Roboto+Flex', category: 'sans-serif' },
  { name: 'Roboto Mono', slug: 'Roboto+Mono', category: 'monospace' },
  { name: 'Roboto Slab', slug: 'Roboto+Slab', category: 'serif' },
  { name: 'Rokkitt', slug: 'Rokkitt', category: 'serif' },
  { name: 'Rubik', slug: 'Rubik', category: 'sans-serif' },
  { name: 'Rubik Mono One', slug: 'Rubik+Mono+One', category: 'sans-serif' },
  { name: 'Ruda', slug: 'Ruda', category: 'sans-serif' },
  { name: 'Rufina', slug: 'Rufina', category: 'serif' },
  { name: 'Russo One', slug: 'Russo+One', category: 'sans-serif' },
  { name: 'Sacramento', slug: 'Sacramento', category: 'handwriting' },
  { name: 'Saira', slug: 'Saira', category: 'sans-serif' },
  { name: 'Saira Condensed', slug: 'Saira+Condensed', category: 'sans-serif' },
  { name: 'Satisfy', slug: 'Satisfy', category: 'handwriting' },
  { name: 'Sawarabi Gothic', slug: 'Sawarabi+Gothic', category: 'sans-serif' },
  { name: 'Secular One', slug: 'Secular+One', category: 'sans-serif' },
  { name: 'Shadows Into Light', slug: 'Shadows+Into+Light', category: 'handwriting' },
  { name: 'Signika', slug: 'Signika', category: 'sans-serif' },
  { name: 'Signika Negative', slug: 'Signika+Negative', category: 'sans-serif' },
  { name: 'Silkscreen', slug: 'Silkscreen', category: 'display' },
  { name: 'Slabo 27px', slug: 'Slabo+27px', category: 'serif' },
  { name: 'Smooch Sans', slug: 'Smooch+Sans', category: 'sans-serif' },
  { name: 'Sono', slug: 'Sono', category: 'sans-serif' },
  { name: 'Sora', slug: 'Sora', category: 'sans-serif' },
  { name: 'Sorts Mill Goudy', slug: 'Sorts+Mill+Goudy', category: 'serif' },
  { name: 'Source Code Pro', slug: 'Source+Code+Pro', category: 'monospace' },
  { name: 'Source Sans 3', slug: 'Source+Sans+3', category: 'sans-serif' },
  { name: 'Source Serif 4', slug: 'Source+Serif+4', category: 'serif' },
  { name: 'Space Grotesk', slug: 'Space+Grotesk', category: 'sans-serif' },
  { name: 'Space Mono', slug: 'Space+Mono', category: 'monospace' },
  { name: 'Special Elite', slug: 'Special+Elite', category: 'display' },
  { name: 'Spectral', slug: 'Spectral', category: 'serif' },
  { name: 'Spline Sans', slug: 'Spline+Sans', category: 'sans-serif' },
  { name: 'Staatliches', slug: 'Staatliches', category: 'display' },
  { name: 'Stint Ultra Condensed', slug: 'Stint+Ultra+Condensed', category: 'display' },
  { name: 'Suez One', slug: 'Suez+One', category: 'serif' },
  { name: 'Syne', slug: 'Syne', category: 'sans-serif' },
  { name: 'Syne Mono', slug: 'Syne+Mono', category: 'monospace' },
  { name: 'Tajawal', slug: 'Tajawal', category: 'sans-serif' },
  { name: 'Tangerine', slug: 'Tangerine', category: 'handwriting' },
  { name: 'Teachers', slug: 'Teachers', category: 'sans-serif' },
  { name: 'Teko', slug: 'Teko', category: 'sans-serif' },
  { name: 'Tektur', slug: 'Tektur', category: 'display' },
  { name: 'Tenor Sans', slug: 'Tenor+Sans', category: 'sans-serif' },
  { name: 'The Nautigal', slug: 'The+Nautigal', category: 'handwriting' },
  { name: 'Tilt Neon', slug: 'Tilt+Neon', category: 'display' },
  { name: 'Tilt Warp', slug: 'Tilt+Warp', category: 'display' },
  { name: 'Titillium Web', slug: 'Titillium+Web', category: 'sans-serif' },
  { name: 'Ubuntu', slug: 'Ubuntu', category: 'sans-serif' },
  { name: 'Ubuntu Condensed', slug: 'Ubuntu+Condensed', category: 'sans-serif' },
  { name: 'Ubuntu Mono', slug: 'Ubuntu+Mono', category: 'monospace' },
  { name: 'Unbounded', slug: 'Unbounded', category: 'display' },
  { name: 'Unna', slug: 'Unna', category: 'serif' },
  { name: 'Unica One', slug: 'Unica+One', category: 'display' },
  { name: 'Urbanist', slug: 'Urbanist', category: 'sans-serif' },
  { name: 'Vampiro One', slug: 'Vampiro+One', category: 'display' },
  { name: 'Varela Round', slug: 'Varela+Round', category: 'sans-serif' },
  { name: 'Vina Sans', slug: 'Vina+Sans', category: 'display' },
  { name: 'Vollkorn', slug: 'Vollkorn', category: 'serif' },
  { name: 'Vollkorn SC', slug: 'Vollkorn+SC', category: 'serif' },
  { name: 'Wix Madefor Display', slug: 'Wix+Madefor+Display', category: 'sans-serif' },
  { name: 'Wix Madefor Text', slug: 'Wix+Madefor+Text', category: 'sans-serif' },
  { name: 'Work Sans', slug: 'Work+Sans', category: 'sans-serif' },
  { name: 'Yaldevi', slug: 'Yaldevi', category: 'sans-serif' },
  { name: 'Yanone Kaffeesatz', slug: 'Yanone+Kaffeesatz', category: 'sans-serif' },
  { name: 'Yantramanav', slug: 'Yantramanav', category: 'sans-serif' },
  { name: 'Yeseva One', slug: 'Yeseva+One', category: 'display' },
  { name: 'Young Serif', slug: 'Young+Serif', category: 'serif' },
  { name: 'Zen Kaku Gothic New', slug: 'Zen+Kaku+Gothic+New', category: 'sans-serif' },
  { name: 'Zen Maru Gothic', slug: 'Zen+Maru+Gothic', category: 'sans-serif' },
  { name: 'Zen Old Mincho', slug: 'Zen+Old+Mincho', category: 'serif' },
  { name: 'Zeyada', slug: 'Zeyada', category: 'handwriting' },
  { name: 'Zilla Slab', slug: 'Zilla+Slab', category: 'serif' },
  { name: 'Zilla Slab Highlight', slug: 'Zilla+Slab+Highlight', category: 'display' },
];

export default GOOGLE_FONTS;

/**
 * Get the CSS API URL for loading a font in the browser.
 * @param {string} slug - Google Fonts slug (e.g. "Open+Sans")
 * @returns {string} Full CSS API URL
 */
export function getFontCssUrl(slug) {
  return `https://fonts.googleapis.com/css2?family=${slug}:wght@400;600;700&display=swap`;
}

/**
 * Get a @font-face CSS rule for a custom (non-Google) font loaded from a URL.
 * @param {string} name - Font family name
 * @param {string} url - URL to the woff2 font file
 * @returns {string} CSS @font-face rule
 */
export function getCustomFontFaceRule(name, url) {
  return `@font-face { font-family: '${name}'; src: url('${url}') format('woff2'); font-weight: 100 900; font-display: swap; }`;
}
